export { default } from './StatementQuestionContainer';
